var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9221 5.85412L14.9024 6.0677L15.0436 6.22916L16.5863 7.99309L15.043 9.76401L14.9025 9.92532L14.9221 10.1384L15.1369 12.4695L12.8567 12.9874L12.647 13.0351L12.5373 13.2201L11.3437 15.2348L9.19729 14.3131L8.99932 14.2281L8.80158 14.3136L6.65629 15.2411L5.46302 13.2207L5.35342 13.0352L5.14325 12.9874L2.86299 12.4695L3.0779 10.1308L3.09752 9.91724L2.95637 9.75584L1.41424 7.9925L2.95637 6.22916L3.09752 6.06776L3.0779 5.85425L2.8631 3.51669L5.14197 3.00537L5.35262 2.9581L5.46267 2.77236L6.65629 0.757733L8.80271 1.67943L9 1.76415L9.19729 1.67943L11.3437 0.757732L12.5373 2.77236L12.647 2.95743L12.8567 3.00508L15.1369 3.52301L14.9221 5.85412Z",
    fill: "#009FE3",
    stroke: "#009FE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56753 9.31259L5.82753 7.56509L4.71753 8.68259L7.56753 11.5401L13.0725 6.02009L11.9625 4.90259L7.56753 9.31259Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.585f6a1e5c368046f56816b21270e579.svg";
export { ForwardRef as ReactComponent };